import { render, staticRenderFns } from "./DocumentDownloadLink.vue?vue&type=template&id=6b759a0a&scoped=true&"
import script from "./DocumentDownloadLink.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DocumentDownloadLink.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DocumentDownloadLink.vue?vue&type=style&index=0&id=6b759a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b759a0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b759a0a')) {
      api.createRecord('6b759a0a', component.options)
    } else {
      api.reload('6b759a0a', component.options)
    }
    module.hot.accept("./DocumentDownloadLink.vue?vue&type=template&id=6b759a0a&scoped=true&", function () {
      api.rerender('6b759a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/DocumentDownloadLink.vue"
export default component.exports